'use strict';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
export default class Loader extends PureComponent {
  render() {
    const component = this,
      props = this.props;
    let base_class = 'c-loader',
      class_name = props.className;
    const text = props.text ? /*#__PURE__*/React.createElement("div", {
      className: "c-loader__txt"
    }, props.text) : undefined;
    if (typeof props.bemit === 'string') {
      class_name += ' ' + base_class + '--' + props.bemit;
    } else {
      props.bemit.forEach(function (bem_modifier, index) {
        class_name += ' ' + base_class + '--' + bem_modifier;
      });
    }
    const loader = /*#__PURE__*/React.createElement("div", {
      className: class_name
    }, /*#__PURE__*/React.createElement("svg", {
      className: "c-loader__svg",
      width: "135",
      height: "140",
      viewBox: "0 0 135 140",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor"
    }, /*#__PURE__*/React.createElement("rect", {
      y: "10",
      width: "15",
      height: "120",
      rx: "4"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "height",
      begin: "0.5s",
      dur: "1s",
      values: "120;110;100;90;80;70;60;50;40;140;120",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), /*#__PURE__*/React.createElement("animate", {
      attributeName: "y",
      begin: "0.5s",
      dur: "1s",
      values: "10;15;20;25;30;35;40;45;50;0;10",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "30",
      y: "10",
      width: "15",
      height: "120",
      rx: "4"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "height",
      begin: "0.25s",
      dur: "1s",
      values: "120;110;100;90;80;70;60;50;40;140;120",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), /*#__PURE__*/React.createElement("animate", {
      attributeName: "y",
      begin: "0.25s",
      dur: "1s",
      values: "10;15;20;25;30;35;40;45;50;0;10",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "60",
      width: "15",
      height: "140",
      rx: "4"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "height",
      begin: "0s",
      dur: "1s",
      values: "120;110;100;90;80;70;60;50;40;140;120",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), /*#__PURE__*/React.createElement("animate", {
      attributeName: "y",
      begin: "0s",
      dur: "1s",
      values: "10;15;20;25;30;35;40;45;50;0;10",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "90",
      y: "10",
      width: "15",
      height: "120",
      rx: "4"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "height",
      begin: "0.25s",
      dur: "1s",
      values: "120;110;100;90;80;70;60;50;40;140;120",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), /*#__PURE__*/React.createElement("animate", {
      attributeName: "y",
      begin: "0.25s",
      dur: "1s",
      values: "10;15;20;25;30;35;40;45;50;0;10",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), /*#__PURE__*/React.createElement("rect", {
      x: "120",
      y: "10",
      width: "15",
      height: "120",
      rx: "4"
    }, /*#__PURE__*/React.createElement("animate", {
      attributeName: "height",
      begin: "0.5s",
      dur: "1s",
      values: "120;110;100;90;80;70;60;50;40;140;120",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), /*#__PURE__*/React.createElement("animate", {
      attributeName: "y",
      begin: "0.5s",
      dur: "1s",
      values: "10;15;20;25;30;35;40;45;50;0;10",
      calcMode: "linear",
      repeatCount: "indefinite"
    }))), text);
    return loader;
  }
}
Loader.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  bemit: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.array.isRequired])
};
Loader.defaultProps = {
  bemit: []
};
